import { EnvironmentKind } from "./environment.kind";
import { InterfaceData } from "./interface.data";
import { SupplierDocumentKind } from "./supplier.document.kind";
import { SupplierDocumentStatusKind } from "./supplier.document.status.kind";

export class SupplierRequestData {
  Environment: EnvironmentKind;
  InterfaceData: InterfaceData;
  Request: SupplierRequestData;
  DocumentKind: SupplierDocumentKind;
  DocumentId: string;
  DocumentStatus: SupplierDocumentStatusKind;
  DocumentFromDate: Date | null;
  DocumentToDate: Date | null;
}